import Vue from 'vue'
import HomePage from '../views/HomePage/index.vue'
import Admin from '../views/Admin/index.vue'
import SfjsIframe from '../views/Admin/SfjsIframe.vue'
// import OrganizationPage from '../views/OrganizationPage/index.vue'
// import OnlineOffice from '../views/OnlineOffice/index.vue'
// import BackManagement from '../views/BackManagement/index.vue'
// import CommunicationManual from '../views/CommunicationManual/index.vue'
// import SoftwareDownload from '../views/SoftwareDownload/index.vue'
import SpecialWork from '../views/SpecialWork/index.vue'
import ColumnWindow from '../views/columnWindow/index.vue'
import ColumnZtWindow from '../views/columnZtWindow/index.vue'
import CaseLibrary from '../views/CaseLibrary/index.vue'
import Special from '../views/Special/index.vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
const routes = [
  {
    path: '/',
    name: 'Admin',
    component: Admin,
    children: [
      {
        path: '/',
        name: 'SfjsIframe',
        component: SfjsIframe,
      },
    ]
  },
  // {
  //   path: '/organization',
  //   name: 'OrganizationPage',
  //   component: OrganizationPage,
  // },
  // {
  //   path: '/onlineOffice',
  //   name: 'OnlineOffice',
  //   component: OnlineOffice,
  // },
  // {
  //   path: '/backManagement',
  //   name: 'BackManagement',
  //   component: BackManagement,
  // },
  // {
  //   path: '/communicationManual',
  //   name: 'CommunicationManual',
  //   component: CommunicationManual,
  // },
  // {
  //   path: '/softwareDownload',
  //   name: 'SoftwareDownload',
  //   component: SoftwareDownload,
  // },
  {
    path: '/specialWork',
    name: 'SpecialWork',
    component: SpecialWork,
  },
  {
    path: '/columnWindow',
    name: 'ColumnWindow',
    component: ColumnWindow,
  },
  {
    path: '/columnZtWindow',
    name: 'ColumnZtWindow',
    component: ColumnZtWindow,
  },
  {
    path: '/caseLibrary',
    name: 'CaseLibrary',
    component: CaseLibrary,
  },
  {
    path: '/special',
    name: 'Special',
    component: Special,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// 在你的Vue Router实例中添加beforeEach路由守卫
router.beforeEach((to, from, next) => {
  // 使用setTimeout模拟延迟1秒
  setTimeout(() => {
    next(); // 允许路由继续
  }, 500);
});

export default router